import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

const UploadService = {
  getAllDocuments: async () => {
    try {
      const res = await axios.get(`${ENDPOINT.employeeUploadDetails}/`);
      return res.data;
    } catch (error) {
      console.error("Error fetching documents", error);
      throw error;
    }
  },

 

 getDocumentsByEmpId: async (emp_id) => {
  try {
    const response = await axios.get(`${ENDPOINT.employeeUploadDetails}/${emp_id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching documents by emp_id:", error);
    throw error;
  }
},


  createDocument: async (payload) => {
    try {
      const res = await axios.post(`${ENDPOINT.employeeUploadDetails}/`, payload);
      return res.data;
    } catch (error) {
      console.error("Error creating document", error);
      throw error;
    }
  },

  updateDocument: async (id, payload) => {
    try {
      const res = await axios.put(`${ENDPOINT.employeeUploadDetails}/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("Error updating document", error);
      throw error;
    }
  },

  deleteDocument: async (id) => {
    try {
      const res = await axios.delete(`${ENDPOINT.employeeUploadDetails}/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting document", error);
      throw error;
    }
  },

  uploadFile: async (file) => {
    try {
      const formData = new FormData();
      formData.append("document", file);

      const res = await axios.post(`${ENDPOINT.employeeUploadDetails}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (error) {
      console.error("Error uploading file", error);
      throw error;
    }
  },

  updateFile: async (id, file) => {
    try {
      const formData = new FormData();
      formData.append("document", file);

      const res = await axios.put(`${ENDPOINT.employeeUploadDetails}/upload/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (error) {
      console.error("Error updating file", error);
      throw error;
    }
  },

  deleteFileByFilename: async (filename) => {
    try {
      const res = await axios.delete(`${ENDPOINT.employeeUploadDetails}/file/${filename}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting file", error);
      throw error;
    }
  },
};




export default UploadService;
